import {
	GET_ACCOUNT_DETAILS,
	LOGOUT,
	LOGGED,
	REFRESH_TOKEN,
	SHOW_MODAL_AUTH,
	SAVE_AUTH_TOKEN
} from '@/redux/actions/auth.actions'

const initialState = {
	error: false,
	loading: false,
	logged: null,
	account: null,
	showModalAuth: false,
	token: null
}

const error = (state = initialState.error, action) => {
	switch (action.type) {
		case GET_ACCOUNT_DETAILS.REQUEST:
		case GET_ACCOUNT_DETAILS.SUCCESS:
		case LOGOUT.REQUEST:
		case LOGOUT.SUCCESS:
			return false
		case GET_ACCOUNT_DETAILS.FAILURE:
		case LOGOUT.FAILURE:
			return true
		default:
			return state
	}
}

const loading = (state = initialState.loading, action) => {
	switch (action.type) {
		case GET_ACCOUNT_DETAILS.REQUEST:
		case LOGOUT.REQUEST:
			return true
		case GET_ACCOUNT_DETAILS.SUCCESS:
		case GET_ACCOUNT_DETAILS.FAILURE:
		case LOGOUT.SUCCESS:
		case LOGOUT.FAILURE:
			return false
		default:
			return state
	}
}

const logged = (state = initialState.logged, action) => {
	switch (action.type) {
		case LOGOUT.SUCCESS:
		case LOGOUT.FAILURE:
			return false
		case REFRESH_TOKEN.SUCCESS:
		case LOGGED:
			return true
		default:
			return state
	}
}

const account = (state = initialState.account, action) => {
	switch (action.type) {
		case GET_ACCOUNT_DETAILS.SUCCESS:
			return action.payload
		case GET_ACCOUNT_DETAILS.REQUEST:
			return action.payload.silent ? state : null
		case LOGOUT.FAILURE:
		case LOGOUT.SUCCESS:
		case REFRESH_TOKEN.FAILURE:
			return null
		default:
			return state
	}
}

const showModalAuth = (state = initialState.showModalAuth, action) => {
	switch (action.type) {
		case SHOW_MODAL_AUTH:
			return action.payload

		case GET_ACCOUNT_DETAILS.SUCCESS:
		case GET_ACCOUNT_DETAILS.FAILURE:
		case LOGOUT.FAILURE:
		case LOGOUT.SUCCESS:
			return false

		default:
			return state
	}
}

const token = (state = initialState.token, action) => {
	switch (action.type) {
		case SAVE_AUTH_TOKEN:
			return action.payload
		case REFRESH_TOKEN.SUCCESS:
			return action.payload.jwtToken
		case LOGOUT.SUCCESS:
		case REFRESH_TOKEN.FAILURE:
			return null
		default:
			return state
	}
}

export default {
	name: 'auth',
	reducers: {
		error,
		loading,
		logged,
		account,
		token,
		showModalAuth
	}
}
